<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-checkbox class="with-info-icon accent-button" formControlName="waitingArchiveModeEnabled" tabindex="1">Ne pas archiver directement.</mat-checkbox>
        <fa-icon
            [icon]="faCircleInfo"
            class="info-icon"
            matTooltip="Si cette option est activée, le dossier ne sera pas archivé directement. Il sera mis en attente d'archivage pendant une periode prédéfini. Il sera archivé lors de la prochaine exécution de l'archivage automatique."
            matTooltipPosition="right"></fa-icon>
    </div>
</form>
